// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".settings[data-v-4631eb6c] {\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./js/app/components/modal/ContactsFilter.vue"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb","sourcesContent":[".settings[data-v-4631eb6c] {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
